import request from '../utils/request'

//登录
export function login(userName, password) {
  return request({
    url: `login`,
    method: 'post',
    data: {
      userName,
      password
    }
  })
}

// 获取手机短信验证码
export function querysmsSend(data) {
  return request({
    url: `smsSend`,
    method: 'post',
    data
  })
}

// 手机验证码登录
export function loginByPhoneCode(data) {
  return request({
    url: `app/login`,
    method: 'post',
    data
  })
}


//获取用户信息
export function getUserInfo() {
  return request({
    url: `getUserInfoByID`,
    method: 'post',
  })
}



//查询产品
export function queryProduct() {
  return request({
    url: `queryProduct`,
    method: 'post',
  })
}




//查询设备
export function queryDevices(productID) {
  return request({
    url: `queryDevices`,
    method: 'post',
    data: {
      productID
    }
  })
}

//删除设备
export function deleteDevice(deviceID) {
  return request({
    url: `deleteDevice`,
    method: 'post',
    data: {
      deviceID
    }
  })
}

//查询设备2
export function queryDevicesAllInfo(params) {
  return request({
    url: `queryDevicesAllInfoByPage`,
    method: 'post',
    data: params
  })
}



//查询所有功能
export function queryFunctions() {
  return request({
    url: `queryFunctions`,
    method: 'post',
  })
}





//查询生产者
export function queryProducers() {
  return request({
    url: `queryProducers`,
    method: 'post',
  })
}



//查询生产者关联产品
export function queryAllRelatedProducts() {
  return request({
    url: `queryAllRelatedProducts`,
    method: 'post',
  })
}


//添加生产者
export function addProducer(producer) {
  return request({
    url: `addProducer`,
    method: 'post',
    data: producer
  })
}


//修改生产者密码
export function editProducerPassword(userName, password) {
  return request({
    url: `editProducerPassword`,
    method: 'post',
    data: {
      userName,
      password
    }
  })
}





//修改生产者
export function editProducer(producer) {
  return request({
    url: `editProducer`,
    method: 'post',
    data: producer
  })
}






//新增关联产品接口
export function producerAddProduct(obj) {
  return request({
    url: `producerAddProduct`,
    method: 'post',
    data: obj
  })
}


//编辑关联产品接口
export function producerSetSerialNumSection(obj) {
  return request({
    url: `producerSetSerialNumSection`,
    method: 'post',
    data: obj
  })
}



//添加产品
export function addProduct(product) {
  return request({
    url: `addProduct`,
    method: 'post',
    data: product
  })
}


//编辑产品
export function editProduct(product) {
  return request({
    url: `editProduct`,
    method: 'post',
    data: product
  })
}





//添加功能
export function addFunction(func) {
  return request({
    url: `addFunction`,
    method: 'post',
    data: func
  })
}





//删除功能
export function deleteFunction(id) {
  return request({
    url: `deleteFunction`,
    method: 'post',
    data: { id }
  })
}



//修改功能
export function editFunction(func) {
  return request({
    url: `editFunction`,
    method: 'post',
    data: func
  })
}


//修改功能
export function editDevice(device) {
  return request({
    url: `editDevice`,
    method: 'post',
    data: device
  })
}


//修改管理员密码
export function editAdminPassword(userName, adminPassword, password) {
  return request({
    url: `editAdminPassword`,
    method: 'post',
    data: {
      userName,
      adminPassword,
      password
    }
  })
}


//匿名用户查询
export function queryDeviceBySerialNumber(serialNumber) {
  return request({
    url: `queryDeviceBySerialNumber`,
    method: 'post',
    data: {
      serialNumber
    }
  })
}


//绑定硬件
export function bindDevice(params) {
  return request({
    url: `bindDevice`,
    method: 'post',
    data: params
  })
}

//解绑硬件
export function unbindDevice(params) {
  return request({
    url: `unbindDevice`,
    method: 'post',
    data: params
  })
}

//查询预激活设备
export function queryPreActivateDevice(params) {
  return request({
    url: `queryPreActivateDevice`,
    method: 'post',
    data: params
  })
}


//查询授权历史
export function queryHistoryNote(params) {
  return request({
    url: `queryHistoryNoteByPage`,
    method: 'post',
    data: params
  })
}

/**
 * 
 * 订单管理
 * 
 */

// 获取订单列表
export function queryOrderList(data) {
  return request({
    url: `order/orderList`,
    method: 'post',
    data
  })
}


/**
 * 
 * 发票管理
 * 
 */

// 获取个人发票信息
export function queryInvoiceInfo(data) {
  return request({
    url: `invoice/getInvoice`,
    method: 'post',
    data
  })
}


// 新增或修改发票信息
export function addOrUpdateInvoice(data) {
  return request({
    url: `invoice/addOrUpdateInvoice`,
    method: 'post',
    data
  })
}

// 获取个人申请开票列表
export function queryApplyInvoiceSelfList(data) {
    return request({
        url: `invoice/applyInvoiceSelfList`,
        method: 'post',
        data
    })
}

// 获取发票信息列表
export function queryInvoiceList(data) {
    return request({
        url: `invoice/invoiceList`,
        method: 'post',
        data
    })
}

// 审核发票信息
export function invoiceAudit(data) {
    return request({
        url: `invoice/audit`,
        method: 'post',
        data
    })
}

// 申请开票列表
export function queryApplyInvoiceList(data) {
    return request({
        url: `invoice/applyInvoiceList`,
        method: 'post',
        data
    })
}

// 处理开票申请
export function dealInvoice(data) {
    return request({
        url: `invoice/dealInvoice`,
        method: 'post',
        data
    })
}

// 提交开票申请
export function applyInvoice(data) {
    return request({
        url: `invoice/applyInvoice`,
        method: 'post',
        data
    })
}

// 生成授权码
export function addExchangeCode(data) {
    return request({
        url: `exchangeCode/generate`,
        method: 'post',
        data
    })
}

// 兑换码使用信息查询（可分页）
export function getExchangeCodeUseInfo(data) {
    return request({
        url: `exchangeCode/getExchangeCodeUseInfo`,
        method: 'post',
        data
    })
}

// 兑换码未使用时修改试用时长
// 入参示例：{ exchangeIds: [1,2,3], periodTime: 30 }（9999 表示永久）
export function updateExchangeCodePeriodTime(data) {
    return request({
        url: `exchangeCode/expandFunctionTime`,
        method: 'post',
        data
    })
}

// 根据类型查询产品
export function queryAppProduct(data) {
    return request({
        url: `queryAppProduct`,
        method: 'post',
        data
    })
}

// 根据App类型查询商品列表
export function querySelectGoodsListByApp(data) {
    return request({
        url: `goods/selectGoodsListByApp`,
        method: 'post',
        data
    })
}














//添加openid
export function addOpenid(data) {
  return request({
    url: `/openId/add`,
    method: 'post',
    data
  })
}

//删除openid
export function deleteOpenid(id) {
  return request({
    url: `/openId/delete`,
    method: 'post',
    data: {
      id
    }
  })
}


//编辑openid
export function modifyOpenid(data) {
  return request({
    url: `/openId/update`,
    method: 'post',
    data
  })
}


//查询所有openid
export function getOpenidList() {
  return request({
    url: `/openId/all`,
    method: 'post',
  })
}

//查询openid
export function getOpenid(openId) {
  return request({
    url: `/openId/get`,
    method: 'post',
    data: {
      openId
    }
  })
}


//设备备案
export function recordDevice(data) {
  return request({
    url: `/recordDevice`,
    method: 'post',
    data
  })
}

//保修期更改
export function setWarrantyPeriod(data) {
  return request({
    url: `/setWarrantyPeriod`,
    method: 'post',
    data
  })
}


//获取短信验证码
export function getPhoneCode(userPhone) {
  return request({
    url: `/smsSend `,
    method: 'post',
    data: {
      userPhone
    }
  })
}












//查询设备的文件
export function getFileList(id) {
  return request({
    url: `/file/docimasy/device`,
    method: 'post',
    data: {
      id
    }
  })
}




//删除设备文件
export function deleteFile(id) {
  return request({
    url: `/file/docimasy/delete`,
    method: 'post',
    data: {
      id
    }
  })
}


//下载设备文件
export function downloadFile(id) {
  return request({
    url: `/file/docimasy/download`,
    method: 'post',
    responseType: 'blob',
    data: {
      id
    }
  })
}

// 解析测量结果
export function parseData(data) {
  return request({
    url: '/parseDeviceMeasureData',
    method: 'post',
    data
  })
}

// 获取设备列表
export function queryDeviceBindAllList(data) {
  return request({
    url: '/deviceBind/all/list',
    method: 'post',
    data
  })
}

// 修改设备授权信息
export function editDeviceBind(data) {
  return request({
    url: '/deviceBind/edit',
    method: 'post',
    data
  })
}

// 解密数据
export function decryptData(data) {
  return request({
    url: '/device/decryptData',
    method: 'post',
    data
  })
}

export function getSignature(query) {
  return request({
    url: '/oa/getSignature',
    method: 'get',
    params: query
  })
}
